// extracted by mini-css-extract-plugin
export default {"content":"order-feed_content__zojaJ","order-list":"order-feed_order-list__udyIf"};